import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

const CommonClass = twMerge(['block', 'p-5', 'border', 'border-aux-gray', 'rounded-xl']);

export const cardVariants = cva(CommonClass, {
  variants: {
    variant: {
      primary: 'max-w-72 min-w-72 min-h-36 max-h-36 w-72 h-36 bg-white hover:bg-emerge-base-2'
    }
  },
  defaultVariants: {
    variant: 'primary'
  }
});
